// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"118":"f653e4ef","375":"d2c93fef"}[chunkId] + ".css";
};